import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-agricola-stepper',
  templateUrl: './agricola-stepper.component.html',
  styleUrls: ['./agricola-stepper.component.css'],
  standalone: false
})
export class AgricolaStepperComponent {

  @Input() steps: string[] = [];
  @Input() currentStep: number = 0;
  @Output() backClick = new EventEmitter<void>();
  @Output() stepClick = new EventEmitter<number>();

  onBackClick(): void {
    this.backClick.emit();
  }

  onStepClick(index: number): void {
    if (index <= this.currentStep) {
      this.stepClick.emit(index);
    }
  }

  isCompleted(index: number): boolean {
    return index < this.currentStep;
  }

  isActive(index: number): boolean {
    return index === this.currentStep;
  }

  isFuture(index: number): boolean {
    return index > this.currentStep;
  }

}

